var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneFrame(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 347,
    height: 706,
    viewBox: "0 0 347 706",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1908_26973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 173.088C0 171.722 1.10706 170.615 2.47268 170.615H4.94537V188.748H2.47268C1.10706 188.748 0 187.641 0 186.276V173.088Z",
    fill: "#37424D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 281.886C0 280.52 1.10706 279.413 2.47268 279.413H4.94537V338.758H2.47268C1.10706 338.758 0 337.65 0 336.285V281.886Z",
    fill: "#37424D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347 236.554C347 235.188 345.893 234.081 344.527 234.081H342.055V331.34H344.527C345.893 331.34 347 330.233 347 328.867V236.554Z",
    fill: "#37424D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 211.002C0 209.636 1.10706 208.529 2.47268 208.529H4.94537V267.874H2.47268C1.10706 267.874 0 266.767 0 265.401V211.002Z",
    fill: "#37424D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.47266,
    y: 2.47266,
    width: 342.055,
    height: 702.242,
    rx: 53.5748,
    fill: "url(#paint0_linear_1908_26973)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.41797,
    y: 7.41797,
    width: 332.164,
    height: 692.352,
    rx: 49.4537,
    fill: "#232020"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1908_26973)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.957,
    y: 18.957,
    width: 309.086,
    height: 669.273,
    rx: 34.6176,
    fill: "#232020"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.957,
    y: 18.957,
    width: 309.086,
    height: 670.097,
    fill: "url(#pattern0)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1908_26973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.432 18.957H236.705V31.3205C236.705 39.059 230.432 45.3323 222.693 45.3323H123.444C115.705 45.3323 109.432 39.059 109.432 31.3205V18.957Z",
    fill: "#232020"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.622 18.957H105.501V18.957C107.686 18.9571 109.457 20.7281 109.457 22.9128C109.457 22.9682 109.456 23.0233 109.453 23.0782H109.622V18.957Z",
    fill: "#232020"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.554 18.957H240.675V18.957C240.675 18.957 240.675 18.957 240.675 18.957C238.49 18.957 236.719 20.7281 236.719 22.9128C236.719 22.9682 236.72 23.0233 236.722 23.0782H236.554V18.957Z",
    fill: "#232020"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.755,
    cy: 30.4962,
    r: 6.59382,
    fill: "#0F0E0E"
  })), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 2.47266,
    y: 100.556,
    width: 4.94537,
    height: 12.3634,
    fill: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 2.47266,
    y: 590.972,
    width: 4.94537,
    height: 12.3634,
    fill: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 339.582,
    y: 100.556,
    width: 4.94537,
    height: 12.3634,
    fill: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 339.582,
    y: 590.972,
    width: 4.94537,
    height: 12.3634,
    fill: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 260.456,
    y: 7.41797,
    width: 4.94537,
    height: 12.3634,
    transform: "rotate(-90 260.456 7.41797)",
    fill: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 79.126,
    y: 704.715,
    width: 4.94537,
    height: 12.3634,
    transform: "rotate(-90 79.126 704.715)",
    fill: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.834,
    y: 10.7148,
    width: 45.3325,
    height: 6.59382,
    rx: 3.29691,
    fill: "#0F0E0E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1908_26973",
    transform: "translate(-0.000615783) scale(0.00133498 0.000615764)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1908_26973",
    x1: 173.5,
    y1: 2.47266,
    x2: 173.5,
    y2: 704.715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#343D47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E6277"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1908_26973"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 347,
    height: 706,
    rx: 34,
    fill: "#232020"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1908_26973"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.957,
    y: 18.957,
    width: 309.086,
    height: 669.273,
    rx: 34.6176,
    fill: "#232020"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1908_26973"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.957,
    y: 18.957,
    width: 309.086,
    height: 669.273,
    rx: 34.6176,
    fill: "#232020"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneFrame);
export default __webpack_public_path__ + "static/media/phone-frame.9cd6c701aae2f2edde15d64b44cc3aa2.svg";
export { ForwardRef as ReactComponent };